// extracted by mini-css-extract-plugin
module.exports = {"root":"style-module__root___2TmW1","large":"style-module__large___1vITz","medium":"style-module__medium___2n3MM","small":"style-module__small___1dmWN"};